import * as React from "react";
import { useMemo } from "react";
import { useMetrics } from "hooks/useMetrics";
const MetricsMapper = ({ map, computeValue }) => {
  const metricNames = useMemo(() => Object.values(map), [map]);
  const { data: metrics, isLoading } = useMetrics(metricNames);
  if (isLoading || Object.keys(metrics).length === 0) {
    return null;
  }
  const metricsMap = {};
  Object.keys(metrics).forEach((nodeId) => {
    Object.keys(map).forEach((key) => {
      const metricName = map[key];
      if (metrics[nodeId][metricName]) {
        if (!metricsMap[nodeId]) {
          metricsMap[nodeId] = {};
        }
        metricsMap[nodeId][key] = metrics[nodeId][metricName];
      }
    });
  });
  const value = computeValue(metricsMap);
  return /* @__PURE__ */ React.createElement("span", null, value);
};
export default MetricsMapper;
